module.exports = __webpack_public_path__ + "pc/img/main-magazine-img-05.4362edfe.png";